import React, { useState, useEffect } from "react";
import classes from "./ServicesList.module.css";

import ServiceCard from "./ServiceCard/ServiceCard"

//libraries
import axios from "axios";

const ServicesList = (props) => {
  const [services, setServices] = useState([]); //state to store the data fetched
  const [loading, setLoading] = useState("Loading..."); //Stores the message displayed instead of the data (loading or Error)

  useEffect(() => {

    //delete this
    axios
    .get("http://portal.lwah.org.lb:8080/PHPApis/ServListAdv.php?catid=3")
    .then((response) => {
      console.log("REHAB",response.data)
    })
    .catch((error) => {
      console.log(error);
      //sets the msg displayed instead of the data to Error
      setLoading("ERROR! TRY AGAIN LATER");
    });
    //########################################

    //axios fetches data from API
    axios
      .get(props.url)
      .then((response) => {
        console.log(response.data)
        setServices(response.data);
      })
      .catch((error) => {
        console.log(error);
        //sets the msg displayed instead of the data to Error
        setLoading("ERROR! TRY AGAIN LATER");
      });
  }, []);

  return (
    <div className={classes.container}>
      <div className={classes.column}>
        <div className={classes.bigTitle}>{props.title}</div>
        <div className={classes.info}>اضغط على الخدمةالمختصة لحجز موعد</div>
      </div>
      <div className={classes.list}>
        {
          //maps the array of clinics into ClinicCards
          services.length > 0 ? (
            services.map((Service) => {
              if (Service.SubService.length != 0) {
                return <ServiceCard Service={Service} key={Service.ServId} />;
              }
            })
          ) : (
            <div className={classes.Loading}>{loading}</div>
          )
        }
      </div>
    </div>
  );
};
export default ServicesList;
